<template>
  <el-dialog
    :visible.sync="visible"
    class="preview_box"
    :modal="true"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    title="用户信息"
    width="650px"
    >
    <el-row>
      <el-col :span="12"> 用户名: {{ detail.account_name}}</el-col>
      <el-col :span="12"> 来源平台: {{ detail.platform_name}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="12"> 邮箱: {{ detail.email}}</el-col>
      <el-col :span="12"> 手机号: {{ detail.phone}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form
          :inline="true"
          :model="form"
          label-width="100px"
          class="demo-form-inline section__content"
        >
          <el-form-item label="功能权限:">
              <span>智能复核平台</span>
              <el-tree
                :data="options.permission_arr"
                show-checkbox
                node-key="id"
                default-expand-all
                :default-checked-keys="permission_ids_arr"
                :props="defaultProps"
                ref="tree_left"
              >
              </el-tree>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form
          :inline="true"
          :model="form"
          label-width="100px"
          class="demo-form-inline section__content"
        >
          <el-form-item label="项目权限:">
              <el-tree
                :data="options.project_arr"
                show-checkbox
                node-key="id"
                :default-checked-keys="project_arr"
                default-expand-all
                :props="defaultProps"
                ref="tree_right"
              >
              </el-tree>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="preview_box_bottom">
      <el-col>用户ID：{{ detail.status_str}}</el-col>
      <el-col>用户状态：{{ detail.status_str}}</el-col>
      <el-col>创建时间：{{ detail.created_at}}</el-col>
      <el-col>更新时间：{{ detail.updated_at}}</el-col>
    </el-row>
    <el-row>
      <el-button @click="close" class="closeBtn">关闭</el-button>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  name: 'detail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    },
    detail: {
      type: Object,
      default: {}
    },
    options: {
      type: Object,
      default: {}
    }
  },
  watch: {
    detail (val) {
      const { permission_ids, project } = val
      this.permission_ids_arr = permission_ids && permission_ids.includes(',') && permission_ids.split(',').map(Number)
      this.project_arr = project && project.includes(',') && project.split(',').map(Number)
    }
  },
  data () {
    return {
      form: {
        auditors: []
      },
      checkAll: false,
      isIndeterminate: false,
      statusArr: [],
      auditor: [],
      permission_ids_arr: [],
      project_arr: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        disabled: true
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.preview_box {
  ::v-deep
  .el-dialog__header{
      font-size: 15px;
      text-align: center;
      border-bottom: 1px solid #eee;
      .el-dialog__headerbtn{
          display: none
      }
  }
  ::v-deep
  .el-dialog__body{
    padding: 10px 15px;
    .el-row {
      margin-bottom: 10px;
    }
  }
  &_bottom {
    .el-col {
      margin-bottom: 10px
    }
  }
  .closeBtn {
    float: right;
  }
}

</style>
